import * as consts from "../consts";
import axios from "axios";

function handleError(exception, message, dispatch) {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CARDBUILDER:", exception);
  }
  if (message && dispatch) {
    addAlert(
      {
        message: message,
        type: consts.ALERT_TYPE_ERROR,
      },
      dispatch
    );
  }
}

export function addAlert(alert, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_ADD_ALERT,
      payload: alert,
    });
    resolve();
  });
}

export function dismissAlert(dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_DISMISS_ALERT,
    });
    resolve();
  });
}

export function setBusy(busy, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_BUSY,
      payload: busy,
    });
    resolve();
  });
}

export function getCategory(categoryID, dispatch) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${consts.SERVICE_URL}/Categories/`)
      .then((response) => {
        console.log(response.data);
        let category = response.data.find((item) => {
          return item.id == categoryID;
        });
        dispatch({
          type: consts.ACTION_SET_CATEGORY,
          payload: category,
        });
        resolve(category);
      })
      .catch((exception) => {
        handleError(exception, `Unable to retrieve category`, dispatch);
        reject(exception);
      });
  });
}

export function getCharity(ein, dispatch) {
  return new Promise((resolve, reject) => {
    setBusy(true, dispatch);
    axios
      .post(`${consts.SERVICE_URL}/Charities/`, {
        categoryColumnName: "",
        postalCode: "",
        query: ein,
        continuationToken: null,
      })
      .then((response) => {
        let charities = response.data.charities;
        let charity = charities.find((item) => {
          return item.ein == ein;
        });
        if (charity) {
          dispatch({
            type: consts.ACTION_SET_CHARITY,
            payload: charity,
          });
          setBusy(false, dispatch);
          resolve(charity);
        } else {
          throw `Invalid charity ein`;
        }
      })
      .catch((exception) => {
        handleError(exception, `Unable to retrieve charity`, dispatch);
        reject(exception);
      });
  });
}
